import {
  FETCH_CART,
  FETCH_CART_SUCCESS,
  FETCH_CART_FAILED
} from '../../types';

const initialState = {
  cart: {},
  isLoading: false,
  errors: {},
  error: false
}

const fetchCartReducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_CART:
      return {
        ...state,
        isLoading: true,
          cart: action.payload
      }
      case FETCH_CART_SUCCESS:
        return {
          ...state,
          isLoading: false,
            cart: action.payload
        }
        case FETCH_CART_FAILED:
          return {
            ...state,
            isLoading: false,
              errors: action.payload,
              error: true
          }
          default:
            return {
              ...state
            };
  }
}

export default fetchCartReducer;
